import React from "react";

const ErrorText = ({ children }) => {
  return (
    <div className="text-red-600 text-xs italic">{children}</div> // Use `text-red-500` and `italic`
  );
};

export default ErrorText;
